import axios from 'axios';
export { IncuranceActions };
axios.defaults.withCredentials = true
function IncuranceActions()
{
    const baseUrl = ``;
    const tenantVal = `${process.env.REACT_APP_TENANT}`;
    return {
        getInsuaranceQueryParams,
        exportData
    }
 async function getInsuaranceQueryParams(pageNumber: number, pageSize: number,tenant:string, description?: string, code?: string) {
        
        return  axios.get(`${baseUrl}/masterdatavehicle/insurance`,
         { params: { pageNumber: pageNumber, pageSize: pageSize,tenant:tenant, description: description, code: code, } })
    
    }

    async function exportData(tenant:string,description?:string,code?:number){ 
        const params=
        {  
            tenant:tenant,
            description:description,
            code:code,
        }  
        return    axios.get(`${baseUrl}/masterdatavehicle/insurance/excel`,
               { params:params,
                responseType: 'arraybuffer',
             })
    }

}

